import { Conversation, Message } from '@/services/conversations.api'

export function generateTranscriptText(conversation: Conversation, messages: Message[]): string {
  const header = `Conversation Transcript
Customer: ${conversation.customerName}
Started: ${new Date(conversation.startedAt).toLocaleString()}
Channel: ${conversation.channel}
${'='.repeat(50)}

`
  const messageLines = messages
    .map(msg => {
      const timestamp = new Date(msg.timestamp).toLocaleString()
      return `[${timestamp}] ${senderLabel(msg)}:\n${msg.content}\n`
    })
    .join('\n')

  return header + messageLines
}

function senderLabel(msg: Message): string {
  if (msg.role === 'USER') return 'Customer'
  if (msg.role === 'STAFF') return msg.direction === 'inbound' ? 'Customer to staff' : 'Dealer staff'
  return 'AI BDC'
}

export function downloadTranscript(conversation: Conversation, messages: Message[]) {
  const text = generateTranscriptText(conversation, messages)
  const blob = new Blob([text], { type: 'text/plain' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `transcript-${conversation.customerName.replace(/\s+/g, '-')}-${Date.now()}.txt`
  a.click()
  URL.revokeObjectURL(url)
}
